import { inject, Injectable } from '@angular/core';
import { UserMetaService } from '@app/client';
import { map, Observable } from 'rxjs';
import { getUpline, UserRoles, UserRolesLevels } from '../enums/roles.enum';
import { ISelectItem } from '../interfaces/select-item.interface';

@Injectable()
export class UserSharedService {
  userMetaService = inject(UserMetaService);

  calculateNetworkPriority(userRoles: UserRoles[]): UserRoles[] {
    let maxLevel = 0;
    userRoles?.forEach((r) => {
      const level = UserRolesLevels.indexOf(<UserRoles>r);
      if (maxLevel < level) {
        maxLevel = level;
      }
    });

    return UserRolesLevels.slice(maxLevel + 1);
  }

  getNetworkDownlineList(
    bypassNetworkByRoles: string[],
    filterByRoles?: string[],
    rootUserId?: string,
    excludeUsersWithNoNetwork?: boolean,
  ): Observable<ISelectItem[]> {
    return this.userMetaService.getUsersListDownlineFromFusion(bypassNetworkByRoles, filterByRoles, rootUserId).pipe(
      map((res) => {
        if (excludeUsersWithNoNetwork) {
          res = res.filter((r: any) => r.children && r.children[0]);
        }
        return res.map((r) => ({
          value: r.id,
          label: `${r.firstName} ${r.lastName}`,
        }));
      }),
    );
  }

  getOperatorList(): Observable<ISelectItem[]> {
    return this.getNetworkDownlineList([UserRoles.IS_ADMIN, UserRoles.IS_BACKOFFICE_NETWORK_OVERRIDER], []);
  }

  getNetworkUplineList() {
    return this.getNetworkDownlineList(
      [UserRoles.IS_ADMIN, UserRoles.IS_BACK_OFFICE],
      getUpline(UserRoles.IS_AGENTE_SENIOR),
      undefined,
      true,
    );
  }

  getAllAgentsList(): Observable<ISelectItem[]> {
    return this.getNetworkDownlineList(
      [UserRoles.IS_ADMIN, UserRoles.IS_BACK_OFFICE, UserRoles.IS_PROPERTY_FINDER],
      getUpline(UserRoles.IS_AGENTE_PROVA),
      undefined,
    );
  }
}
